<template>
  <div class="mt-4">
    <Card class="px-1 h-fit w-full my-auto" pt:content:class="p-0!">
      <template #header>
        <div v-if="errors.length" class="flex flex-col gap-2">
          <Message severity="error" :closeable="false">
            <div class="flex flex-col gap-1">
              <p v-for="error in errors">{{ error }}</p>
            </div>
          </Message>
        </div>
      </template>
      <template #content>
        <form id="editForm" @submit="editLedger">
          <div class="flex flex-col gap-2">
            <StackedLabelInput name="description" label="Description" />
            <StackedLabelInput name="bankNumber" label="Bank #" />
            <StackedLabelInput name="escrowNumber" label="Escrow #" />
            <StackedLabelInputNumber name="nextCheckNumber" label="Next Check #" />
            <LabeledCheckbox name="active" label="Active" />
          </div>
        </form>
      </template>
      <template #footer>
        <div class="flex justify-end gap-2 mt-4">
          <SubmitButton form="editForm" />
          <CancelButton @click="emit('cancelled')"></CancelButton>
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import { z } from "zod";
import type { CheckingAccount } from "@/types/CheckingAccount";

const errors = ref<string[]>([]);
const ledger = defineModel<CheckingAccount>("ledger", { required: true });

const emit = defineEmits<{
  edited: [];
  cancelled: [];
}>();

const { handleSubmit } = useForm({
  validationSchema: toTypedSchema(
    z.object({
      description: z.string(),
      bankNumber: z.string().max(3),
      escrowNumber: z.string().max(2),
      nextCheckNumber: z.number().nullable(),
      active: z.boolean(),
    })
  ),
  initialValues: {
    description: ledger.value.description,
    bankNumber: ledger.value.bankNumber,
    escrowNumber: ledger.value.escrowNumber,
    nextCheckNumber: ledger.value.nextCheckNumber,
    active: ledger.value.active,
  },
});

const editLedger = handleSubmit((values: any): void => {
  axios.post(`/ledger/${ledger.value.checkingAccountId}/edit`, values).then((response) => {
    // Clear existing errors
    while (errors.value.length) {
      errors.value.pop();
    }

    if (response.data.errors) {
      errors.value.push("Please fix the following errors:");

      for (let error of response.data.errors) {
        errors.value.push(error.message);
      }
    } else {
      success("Success", "Ledger edited");
    }

    emit("edited");
  });
});
</script>
